<ng-container
    *ngIf="{ value: showToolbar$ | async } as showToolbar"
    >
    <ng-container
        *ngIf="showToolbar.value"
        >
        <ng-container
            *ngTemplateOutlet="toolbar"
        >
        </ng-container>
    </ng-container>
</ng-container>

<ng-template
    #toolbar
>
    <div class="bg-body py-2 pb-md-2 px-2 px-md-3 hstack gap-3 position-relative">
        @if (toolbarPlacement$ | async; as placement) {
            <button
                class="btn btn-outline-secondary d-flex position-relative px-2"
                [class.d-lg-none]="placement === 'side'"
                data-testid="menu-button"
                (click)="openOffCanvasMenu()"
            >
                <img
                    ngSrc="assets/menu/normal.svg"
                    alt="Settings"
                    width="24"
                    height="24"
                >
                <div
                    class="position-absolute"
                    style="right: -8px; top: -8px;"
                >
                    <ng-template
                        [ngTemplateOutlet]="badge"
                        [ngTemplateOutletContext]="{$implicit: requestedBookingsCountPublisher}"
                    >
                    </ng-template>
                </div>
            </button>
            <div class="vr" [class.d-lg-none]="placement === 'side'"></div>
            <app-logo
                [compact]="true"
                [class.d-lg-none]="placement === 'side'"
            >
            </app-logo>
        }
        <h5
            *ngIf="venue$ | async as venue"
            class="m-0 text-truncate py-2 fw-semibold"
        >
            {{ venue.displayName }}
        </h5>
        <div class="d-none d-lg-block vr"></div>
            <div class="position-absolute top-0 start-0 end-0 bottom-0 hstack gap-3 justify-content-center pointer-events-none">
                <div class="d-none d-md-flex px-5 hstack gap-3 gap-lg-4 toolbar-breadcrumbs">
                    <div class="toolbar-breadcrumbs__band">
                        <nav>
                            <ol class="breadcrumb m-0 pe-auto">
                                <li class="breadcrumb-item"
                                *ngFor="let breadcrumb of breadcrumbs$ | async; let last = last"
                                [ngClass]="{'active': last}"
                                >
                                <a
                                *ngIf="!last; else lastBreadcrumb"
                                [routerLink]="[breadcrumb.url]"
                                >
                                {{ breadcrumb.label }}
                            </a>
                            <ng-template #lastBreadcrumb>
                                {{ breadcrumb.label }}
                            </ng-template>
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
</div>
    <hr class="m-0"/>
</ng-template>

<ng-template #badge let-notificationCountPublisher>
    <ng-container
        *ngIf="notificationCountPublisher"
    >
        <div
            *ngIf="notificationCountPublisher.number$ | async as count"
            class="badge bg-danger top-0"
        >
            {{ count | notificationCount }}
        </div>
    </ng-container>
</ng-template>
